module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "level is-mobile lxm-stat"
  }, [_vm._l((_vm.stats), function(s) {
    return [_c('div', {
      staticClass: "level-item has-text-centered",
      on: {
        "click": function($event) {
          _vm.itemClicked(s.to)
        }
      }
    }, [_c('p', {
      staticClass: "lxm-stat__value"
    }, [_vm._v(_vm._s(s.value))]), _vm._v(" "), _c('p', {
      staticClass: "lxm-stat__title"
    }, [_vm._v(_vm._s(s.title))])])]
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5e8ad756", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5e8ad756!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/common/LxmStat.vue
// module id = 856
// module chunks = 0